import React from "react";
import styled from "styled-components";
import GlobalStyle from "../../../../GlobalStyle";
import { createGlobalStyle } from "styled-components";
import Title from "antd/lib/skeleton/Title";
import { XIQ_ONLINE_URL, STATIC_ROOT_PATH } from "../../../../constants/index";

//Library Imports
// application components goes here
// styles goes here

const Nav: React.FC = () => {
  return (
    <>
      <GlobalStyle />
      <Navogation>
        <Nav_item className="d-none">
          <a href="#">Learn more</a>
        </Nav_item>
        <Nav_item className="d-none">
          <a href="#">Pricing</a>
        </Nav_item>
        <Nav_item>
          <a href={`${XIQ_ONLINE_URL}signup-wb?redirectURL=${STATIC_ROOT_PATH}`} className="sign-up">
            Sign up now
          </a>
        </Nav_item>
      </Navogation>
    </>
  );
};

export default Nav;

const Navogation = styled.ul`
  margin: 0px;
  padding: 0px;
  list-style: none;
`;
const Nav_item = styled.li`
  margin: 0px;
  padding: 0 25px;
  display: inline-block;
  &:last-child {
    padding-right: 0;
  }
  a {
    padding: 8px 18px;
    text-decoration: none;
    color: #fff;
    font-family: "Roboto", sans-serif;
    font-weight: 700;
    &.sign-up {
      border: 2px solid #fff;
      border-radius: 20px;
    }
  }
`;
